// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__12FF2","area":"style_area__3eCct"};